import { render, staticRenderFns } from "./RoleAddNew.vue?vue&type=template&id=5a608452&"
import script from "./RoleAddNew.vue?vue&type=script&lang=js&"
export * from "./RoleAddNew.vue?vue&type=script&lang=js&"
import style0 from "./RoleAddNew.vue?vue&type=style&index=0&id=5a608452&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports